<div class="gradient-background">
    <div class="content-wrapper">
        <header class="header">
            <img src="./assets/images/bayer.svg" alt="bayer_logo"/>
            <img src="./assets/images/healthbank_logo.png" alt="healthbank_logo"/>
        </header>
        <div class="content">
            <div class="content__info-section">
                <mat-icon *ngIf="!errorCode"
                          class="material-icons-round content__info-section__icon">{{icon}}</mat-icon>
                <p *ngIf="errorCode" class="content__info-section__error-message">{{errorCode}}</p>
                <p class="content__info-section__text">
                    {{message}}
                </p>
            </div>
        </div>
        <footer class="footer">
            <div class="btn-wrapper">
                <app-button
                        [cssClasses]="'solid__blue-07 full-width'"
                        (buttonClicked)="onReturnToHome()">
                    {{'GENERAL.RETURN_TO_HOME' | translate}}
                </app-button>
            </div>
        </footer>
    </div>
</div>



